module.exports = __webpack_public_path__ + "img/telegram.fab474cf.png";